import { useSelector } from "react-redux"
import type { RootState } from "@/store"
import type { VistaTotemPedidos } from "@/store/totem-pedidos-slice"
import { haOperacaoCritica, passouDoTeto, useOperacaoCritica } from "@/lib/operacao-critica"
import { MS_OCIOSO_CATALOGO_VAZIO, MS_OCIOSO_COM_ITENS } from "./constantes"

export interface VigiaTotem {
    ativo: boolean
    msInatividade: number
}

export function decidirVigia(entrada: { temItens: boolean; emOperacaoCritica: boolean; estouroDoTeto: boolean }): VigiaTotem {
    const pausado = entrada.emOperacaoCritica && !entrada.estouroDoTeto

    return {
        ativo: !pausado,
        msInatividade: entrada.temItens ? MS_OCIOSO_COM_ITENS : MS_OCIOSO_CATALOGO_VAZIO,
    }
}

export type InatividadeDaTela = 'NENHUMA' | 'SILENCIOSA' | 'COM_AVISO'

// Consumo vazio é o começo do atendimento e recomeça calado; com carrinho, o cliente voltou do cardápio e é avisado antes do descarte.
export function inatividadeDaTela(view: VistaTotemPedidos, temItens: boolean): InatividadeDaTela {
    if (view === 'VIEW_ATRACAO' || view === 'VIEW_CONFIRMADO') return 'NENHUMA'
    if (view === 'VIEW_CONSUMO' && !temItens) return 'SILENCIOSA'

    return 'COM_AVISO'
}

export function useVigiaTotem(): VigiaTotem {
    const temItens = useSelector((s: RootState) => s.carrinho.itens.length > 0)
    useOperacaoCritica()

    return decidirVigia({
        temItens,
        emOperacaoCritica: haOperacaoCritica(),
        estouroDoTeto: passouDoTeto(),
    })
}
